let url = "https://api.skybuybd.com/v2/admin";
// let url = "http://192.168.0.124:3070/v2/admin";
export let cdnUrl = "https://cdnapi.skybuybd.com/v1/admin";
export let cdnUrlV2 = "https://cdnapi.skybuybd.com/v2/admin";
export let baseUrl = "https://api.skybuybd.com/v2";
// export let baseUrl = "http://192.168.0.124:3070/v2";
export default url;
